import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64ab4d8e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=64ab4d8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab4d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ab4d8e')) {
      api.createRecord('64ab4d8e', component.options)
    } else {
      api.reload('64ab4d8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64ab4d8e&scoped=true", function () {
      api.rerender('64ab4d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/admin/index.vue"
export default component.exports